<p-progressBar [showValue]="false" [value]="value" styleClass="no-animation-progress-bar"></p-progressBar>
